import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DaoService } from './dao.service';

@Injectable({
 providedIn: 'root'
})
export class AuthService {

 private authenticated = false;
 private redirectUrl: string;

 constructor(private router: Router,private daoService: DaoService) { }

 public setRedirectUrl(url: string) {
   this.redirectUrl = url;
 }

/*  public submitmobilenumber(countrycode: string, mobile: number): void {
   this.authenticated = true;
    this.daoService.sendOtp(mobile).subscribe((data:any) => {
      return data;
    });
   // this.router.navigate(['/login']);
} */

 public auth(otp: number): void {
  otp = +otp;
   this.authenticated = true;
  
 }

 public isAuthenticated(): boolean {
   return this.authenticated;
 }

}
